var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compare-gallery-view",on:{"click":function($event){return _vm.close()}}},[_c('gallery-view',{staticClass:"gallery1",attrs:{"images":_vm.images1}}),_c('gallery-view',{staticClass:"gallery2",attrs:{"images":_vm.images2,"flip":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }